import {React, useEffect, useState, useRef} from 'react';
import '../App.css';
import './about.css';
import { Helmet } from "react-helmet";
import { useScrollBehavior } from './useScrollBehavior.js';
//import SlideInDiv from './slider.js'
//import BGwordanimation from './BGwordanimation.js'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { GiWillowTree } from "react-icons/gi";
import { TbShieldCheckFilled } from "react-icons/tb";
import useHorizontalScroll from './useHorizontalScroll';
import Image4 from '../images/image4.webp';
import Image5 from '../images/image5.webp';
import Image6 from '../images/image6.webp';
import Image7 from '../images/image7.webp';
//import { IoSchoolOutline } from "react-icons/io5";
//import { LuShieldAlert } from "react-icons/lu";
//import { GiTreeBranch } from "react-icons/gi";
//import { TbTrees } from "react-icons/tb";
//import { GiPineTree } from "react-icons/gi";
import { GiPalmTree } from "react-icons/gi";
import { MdStarBorderPurple500 } from "react-icons/md";
import { GiBurningTree } from "react-icons/gi";
import { PiWarningOctagonBold } from "react-icons/pi";
import SlideComponent from './SlideComponent.js';
import { useNavigate } from "react-router-dom";
import Testimonials from './testimonials.js'
import Arborist from './arborist.js'
import Footer from './footer4.js'

const testimonialsData = [
	{
	  name: 'Michael B',
	  review: 'Sam’s Tree Service did an amazing job! Highly recommend.',
	  image: Image4, 
	},
	{
	  name: 'Mrs Tran',
	  review: 'Affordable and professional service. My yard looks great!',
	  image: Image5,
	},
	{
	  name: 'Denies H',
	  review: 'Quick and efficient! The team was courteous and clean.',
	  image: Image6,
	},
	{
	  name: 'Marilyn Neil',
	  review: 'They removed a dangerous tree with precision and care.',
	  image: Image7,
	},
  ];

const About = () => {

	useScrollBehavior();
	const [count, setCount] = useState(0);
	const [percentage, setPercentage] = useState(0);
	const [experience, setExperience] = useState(0); 
	const ref = useRef(null);
	const ref2 = useRef(null);
	const ref3 = useRef(null);
	const { scrollRef, scrollLeft, scrollRight } = useHorizontalScroll();
	const [isVisibleLinks2, setIsVisibleLinks2] = useState(false);
	const [isVisibleCenter2, setIsVisibleCenter2] = useState(false);
	const linksRef2 = useRef(null);
	const centerRef2 = useRef(null);
	const navigate = useNavigate(); 

	

			  const handleScroll3 = () => {
				if (linksRef2.current) {
				  const linksRect2 = linksRef2.current.getBoundingClientRect();
				  const triggerOffsetLinks2 = 100;
				  const triggerPointLinks2 = window.innerHeight - triggerOffsetLinks2;
				  const isAboveTriggerPointLinks2 = linksRect2.top < triggerPointLinks2;
				  setIsVisibleLinks2(isAboveTriggerPointLinks2);
				}

				if (centerRef2.current) {
					const centerRect2 = centerRef2.current.getBoundingClientRect();
					const triggerOffsetCenter2 = 200; // Adjust this value for different trigger points
					const triggerPointCenter2 = window.innerHeight - triggerOffsetCenter2;
					const isAboveTriggerPointCenter2 = centerRect2.top < triggerPointCenter2;
					setIsVisibleCenter2(isAboveTriggerPointCenter2);
				  }
			  
				};
			  
				useEffect(() => {
				window.addEventListener('scroll', handleScroll3);
				handleScroll3(); // Check visibility on initial render
				return () => {
				  window.removeEventListener('scroll', handleScroll3);
				};
				}, []);
			  
				//useEffect(() => {
					// Scroll to the top when the component mounts
					//window.scrollTo(0, 0);
				  //}, []); // Empty dependency array ensures this effect runs only once
				
				
				useEffect(() => {
					const hash = window.location.hash.substring(1);
					if (hash) {
					  const targetElement = document.getElementById(hash);
					  if (targetElement) {
						targetElement.scrollIntoView({ behavior: 'smooth' });
					  }
					}
				  }, []);

	return (
		<>
		<Helmet>
  			<title>About Us | Sam's Tree Service</title>
  			<meta name="description" content="Learn more about Sam's Tree Service, our team, and our commitment to safe and professional tree care." />
			<link rel="canonical" href="https://samstreeservice.com/about" />
		</Helmet>

		<div id='main_aboutDiv'>
			<div className="background-image2"></div>
			<div className="module_about" id="module_about1">
				<div id='about_div1'>
				<div id='cover_about_div1'>
				<div id='about_title'>
							<h1>Get to Know Us</h1>
					</div>
				</div>
				</div>	
			</div>
			<div className="module_about" id="module_about2">
				<div id='module_about2_subdiv'>
					<div id='about_img_container1'>
					<div id='about_img1_background'></div>
					<div id='about_img1'></div>
					</div>
					<div id='textbox_about1'>
						<div id='textbox_about1_icon1'>
							<div id='textbox_about1_icon2'><h1> - - - - - -&nbsp;&nbsp;</h1>
							</div><div id='textbox_about1_icon3'><GiPalmTree /></div>
							<div id='textbox_about1_icon4'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
						</div>
						<div id='textbox_about1_text1'>
						<h1>Solving hazardous tree problems is at the root of what we do at Sam's.</h1>
						<p> <strong>Sam Giauque</strong>, the Founder and Owner of <strong>Sam's Tree Service</strong> thrives 
							on tackling the toughest challenges homeowners and businesses face when dealing with 
							dangerous trees.
						</p>
							<p>Sam's journey began in 2017, in the wake of Hurricane Irma. After stepping 
							in to safely remove a hazardous tree no one else dared to handle, he discovered 
							his calling.  <strong>"Nobody wanted to cut it down," </strong>Sam recalls. "So, I figured out 
							how to get it done, hired a crew, and made it happen. That's when I realized there 
							was a real need for companies specializing in removing dangerous trees—and I ran 
							with that idea and never looked back. 
						</p>
						</div>
					</div>

					<div id='textbox_about2'>
						<div id='textbox_about2_icon1'>
							<div id='textbox_about2_icon2'><h1> - - - - - -&nbsp;&nbsp;</h1>
							</div><div id='textbox_about2_icon3'><GiPalmTree /></div>
							<div id='textbox_about2_icon4'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
						</div>
						<SlideComponent />
						
					</div>
					<div id='about_img_container2'>
					<div id='about_img2_background'></div>
					<div id='about_img2'></div>
					</div>
			</div>
			<div id='spacer_div2'>
				<div id='divlink_container2' ref={linksRef2}>
					<div className={`spacer_div_Link2 ${isVisibleLinks2  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.3s' }}>
							
							<h1><i class="bi bi-houses" style={{ fontSize: '2rem', color: 'green'}}></i>&nbsp;Residential Services</h1>
							<p>We offer expert tree care for your home, including trimming, 
								pruning, and safe tree removal. Our team ensures your trees 
								remain healthy, enhancing your property's beauty and safety.</p>
					</div>
					<div className={`spacer_div_Link2 ${isVisibleLinks2  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.6s' }}>
							
							<h1><i className="bi bi-buildings" style={{ fontSize: '2rem', color: 'green' }}></i>&nbsp;Commercial</h1>
							
							<p>We provide safe, 
								efficient, and budget-friendly tree removal services 
								tailored to meet your commercial needs.</p>
					</div>
					<div className={`spacer_div_Link2 ${isVisibleLinks2  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.9s' }}>
							
							<h1><i className="bi bi-exclamation-diamond"style={{ fontSize: '2rem', color: 'green' }} ></i>&nbsp;24/7 Emergency Services</h1>
							<p>Trust us anytime, day or night, for fast and dependable tree care, 
								safeguarding your property and loved ones when it matters most.
								</p>
					</div>
					
				</div>
				</div>
				
			</div>
			<div className="module_about" id="module_about2_5">
				<div id='about2_5_div1'>
					<div id='about2_5_div1_sub2'>
						<div id='about2_5_div1_heading'>
							<div id='icon_about2_5'>
								<div id='about2_5_text2_1'><h1> - - - - - -&nbsp;&nbsp;&nbsp;&nbsp;</h1>
								</div><div id='icon_about2_5_icon2'><GiWillowTree /></div>
								<div id='about2_5_text2_2'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
							</div>
							<h1>What Makes Us Different?</h1>
							<p>Experience excellence as we elevate your outdoor 
								spaces with premium tree care services. Rely on our 
								expertise and commitment to craft a greener, safer, 
								and more beautiful environment for your enjoyment.</p>
						</div>
							<div id='about2_5_div1_box_container' ref={centerRef2}>
								<div  id='about2_5_div1_box1' className={`about2_5_div1_box ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '.3s' }}>
									<div className='about2_5_div1_box_sub_container'>
									<div className='about2_5_div1_box_sub'>
										<div className='circle_div1'><MdStarBorderPurple500 /></div>
										<h1>Customer Satisfaction</h1>
										<p>We back our work with a 100% satisfaction guarantee for every 
											tree removal, trimming, or cleanup project.</p>
										
									</div>
									<div className='about2_5_div1_box_pic' id='about2_5_div1_box_pic1'></div>
									</div>
								</div>
								<div className={`about2_5_div1_box ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '.6s' }}>
									<div className='about2_5_div1_box_sub_container'>
									<div className='about2_5_div1_box_sub'>
										<div className='circle_div1'><GiBurningTree /></div>
										<h1>dangerous Tree Expertise</h1>
										<p> Trust our expertise and specialized equipment to safely handle the 
											most hazardous situations with precision and care.</p>
										
									</div>
									<div className='about2_5_div1_box_pic' id='about2_5_div1_box_pic2'></div>
									</div>
								</div>
								<div className={`about2_5_div1_box ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '.9s' }}>
									<div className='about2_5_div1_box_sub_container'>
									<div className='about2_5_div1_box_sub'>
										<div className='circle_div1'><PiWarningOctagonBold /></div>
										<h1>Emergency Assistance</h1>
										<p> Contact us anytime for 24/7 emergency assistance. We're ready to respond swiftly to 
											fallen trees, storm cleanup, and dangerous situations.</p>
										
									</div>
									<div className='about2_5_div1_box_pic' id='about2_5_div1_box_pic3'></div>
									</div>
								</div>
							</div>
					</div>
				</div>				

			</div>
			
			<div className="module_about" id="module_about3">

				<Testimonials/>
				
			</div>
			<div className="module_about" id="module_about5">
				
				<Arborist/>
					
			</div>
			<div className="module_about" id="module_about4">
				
					<div id='choose_us_m4'>
						<div id='divider_heading_m4'><h1>Why Choose Us?</h1></div>
						<div id='dividers_container_m4'>
							<div className='dividers_m4'><TbShieldCheckFilled className="check"/><p>Fully insured for your peace of mind</p></div>
							<div className='dividers_m4'><TbShieldCheckFilled className="check"/><p>Emergency tree removal services available 24/7</p></div>
							<div className='dividers_m4'><TbShieldCheckFilled className="check"/><p>Affordable rates and competitive prices</p></div>
							<div id='dividers4_m4' className='dividers_m4'><TbShieldCheckFilled className="check"/><p>Highly trained professionals with years of experience</p></div>
						</div>
					</div>
					
			
			
				
			</div>
			<Footer/>
		</div>
		</>
	);
};

export default About;

